module.exports = __webpack_public_path__ + "static/media/check.eb26f02f.svg";